import DashboardNotifications from './DashboardNotifications';
import React from 'react';
import DashboardActions from './admin/DashboardActions';

export default function AdminDashboard() {
  return (
    <div className="grid grid-cols-3 gap-x-7">
      <div className="col-span-2">
        <DashboardActions/>
      </div>
      <div>
        <DashboardNotifications/>
      </div>
    </div>
  );
}
